// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { NotificationEffects } from './store/effects';
import * as fromNotification from './store/reducer';

// SERVICES
import { NotificationStoreService } from './notification-store.service';
import { NotificationService } from './services/notification.service';

/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: [], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure notification permission ngrx related stuff.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 27-04-2020 notification permission store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('notification', fromNotification.reducer, { metaReducers }),
    EffectsModule.forFeature([NotificationEffects]),
  ],
  declarations: [],
  providers: [
    NotificationService,
    NotificationStoreService,
  ],
})
export class NotificationStoreModule { }
